export const getImportsPath = state => state.paths.imports;
